import { CKEditor } from '@ckeditor/ckeditor5-react';
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { useState } from "react";
import { useSelector } from 'react-redux';
import '../../../resources/css/manage-post.css';
import { useUpdatePostMutation, useDeletePostMutation } from '../../../store';
import Env from '../../../store/env';
import Button from './../../shared/Button';
import ImageUploader from '../../shared/ImageUploader';
import MultiselectControl from '../../shared/MultiselectControl';

export default function PostEdit({ post, labels }) {

    const [model, setModel] = useState(post);
    const [validationErrors, setValidationErrors] = useState([]);
    const { token } = useSelector((state) => state.environment);

    const [updatePost] = useUpdatePostMutation();
    const [deletePost] = useDeletePostMutation();

    const validate = function () {

        let errors = [];

        if (!model.title) {
            errors.push(labels.titleLabel);
        }

        if (!model.categories.length) {
            errors.push(labels.categoriesLabel);
        }

        if (!model.topContent) {
            errors.push(labels.topContentLabel);
        }

        if (!model.topImage) {
            errors.push(labels.imageLabel);
        }

        if (!model.creationDate) {
            errors.push(labels.creationDateLabel);
        }

        if (!model.content) {
            errors.push(labels.contentLabel);
        }

        setValidationErrors(errors);

        return errors.length === 0;
    }
    const validationErrorsRender = validationErrors.map(e => <span key={e}>{e} </span>);

    const handleChange = function (property, value) {

        let newModel = { ...model };
        newModel[property] = value;

        setModel(newModel);
    }

    const handleSave = function () {

        if (validate()) {
            updatePost(model);
            window.history.back();
        }
    }

    const handleCancel = function () {
        window.history.back();
    }

    const handleDelete = function () {
        deletePost(model);
        window.history.back();
    }

    return (
        <div className="manage-post-container">
            <div className="form">
                <div className="row">
                    <div className="cell">

                        <label>{labels.titleLabel}</label>
                        <input type="text" value={model.title} onChange={(e) => handleChange('title', e.target.value)}></input>

                    </div>
                    <div className="cell">

                        <label>{labels.authorLabel}</label>
                        <span>{model.author}</span>

                    </div>
                </div>
                <div className="row">
                    <div className="cell">

                        <label>{labels.categoriesLabel}</label>
                        <MultiselectControl value={model.categories} onChange={(res) => handleChange('categories', res)}></MultiselectControl>

                    </div>
                    <div className="cell">

                        <label>{labels.topContentLabel}</label>
                        <textarea value={model.topContent} onChange={(e) => handleChange('topContent', e.target.value)}></textarea>

                    </div>
                </div>
                <div className="row">
                    <div className="cell">

                        <label>{labels.imageLabel}</label>
                        <ImageUploader model={model.topImage} onChange={(res) => handleChange('topImage', res)}> </ImageUploader>

                    </div>
                    <div className="cell">

                        <label>{labels.creationDateLabel}</label>
                        <input type="date" value={model.creationDate} onChange={(e) => handleChange('creationDate', e.target.value)}></input>

                    </div>
                </div>
                <div className="row">
                    <div className="cell cell-2x">

                        <label>{labels.contentLabel}</label>
                        <CKEditor config={{
                            removePlugins: ['Title', 'MediaEmbedToolbar', 'Markdown'],
                            toolbar: [
                                'undo',
                                'redo',
                                '|',
                                'heading',
                                '|',
                                'bold',
                                'italic',
                                'underline',
                                'strikethrough',
                                '|',
                                'alignment',
                                'outdent',
                                'indent',
                                '|',
                                'bulletedList',
                                'numberedList',
                                'todoList',
                                '|',
                                'link',
                                'imageInsert',
                                'blockQuote',
                                'insertTable',
                                'mediaEmbed',
                                '|',
                                'fontBackgroundColor',
                                'fontColor',
                                'fontFamily',
                                'subscript',
                                'superscript',
                                'horizontalLine',
                                'specialCharacters',
                                '|',
                                'selectAll',
                                'removeFormat',
                                'findAndReplace',
                                'sourceEditing'
                            ],
                            simpleUpload: {
                                uploadUrl: Env.baseUrl + "/images",
                                headers: {
                                    Authorization: `Bearer ${token}`
                                }
                            }
                        }}
                            editor={Editor.Editor}
                            data={model.content}
                            onChange={(_event, editor) => {
                                const editorData = editor.getData();
                                handleChange('content', editorData);
                            }} />

                    </div>
                </div>
                {
                    validationErrorsRender.length > 0 &&
                    <div className="row color-red">
                        <div className="cell cell-2x">
                            <label>{labels.validationLabel}</label>
                            <div>{validationErrorsRender}</div>
                        </div>
                    </div>
                }
                <div className="row">
                    <Button eventHandler={handleSave}>{labels.saveButton}</Button>
                    <Button eventHandler={handleCancel}>{labels.cancelButton}</Button>
                    <Button eventHandler={handleDelete}>{labels.deleteButton}</Button>
                </div>
            </div>
        </div>
    );
}